import type { TFunction } from 'i18next'
import { toast } from 'sonner'

// Shared via the marketing site, which redirects to the app's /c/<token> route.
export function coachInviteLink(token: string) {
  const origin = import.meta.env.PROD ? 'https://goaltree.ai' : window.location.origin
  return `${origin}/c/${token}`
}

export function coachErrorCode(err: unknown): string | null {
  const data = (err as { data?: { kind?: string; code?: string } } | null)?.data
  return data?.kind === 'coach' ? (data.code ?? null) : null
}

export function toastCoachError(err: unknown, t: TFunction) {
  toast.error(t(`coaching.errors.${coachErrorCode(err) ?? 'generic'}`))
}

// Coaching notifications whose actor is the recipient's coach (linked/ended also go to coaches).
export function isFromCoach(n: { type: string; url?: string }) {
  if (n.type === 'coachNote' || n.type === 'coachEdit') return true
  return (n.type === 'coachLinked' || n.type === 'coachEnded') && !!n.url?.startsWith('/settings')
}

// A self-given "Coach " prefix is redundant next to the Coach label ("Coach Jon" → "Jon").
export const bareName = (name: string) => name.replace(/^coach\s+/i, '').trim() || name
export const firstName = (name: string) => bareName(name).split(/\s+/)[0] ?? name
